import React from 'react';
import { calculatePrice } from '../../utils/utils';
import { formatPrice } from './basketUtils';

const BasketSummary = ({ products }) => {
  const { totalPrice, discountedPrice } = calculatePrice({ products });
  const economy = totalPrice - discountedPrice;

  return <div className='basket-summary'>
    <div className='basket-sum-block'>
      <span className='basket-sum-label'>Сума до оплати:</span>
      <div className='basket-sum-prices'>
        {economy > 0 && <span className='basket-sum-old'>{formatPrice(totalPrice)} грн</span>}
        <strong className='basket-sum-total'>{formatPrice(discountedPrice)} грн</strong>
      </div>
    </div>
    {economy > 0 && <div className='basket-sum-savings'>
      <span>Знижка:</span>
      <span className='basket-sum-amount'>{formatPrice(economy)} грн</span>
    </div>}
  </div>;
};

export default BasketSummary;
